import React from "react";
import "./AdCard.css";

function AdCardSkeleton() {
  return (
    <div className="ad-card skeleton">
      <div className="skeleton-image" />
      <div className="skeleton-text short" />
      <div className="skeleton-text" />
      <div className="skeleton-text" />
    </div>
  );
}

export default AdCardSkeleton;
